/*
  Rostund – informationssidor: lyfter upp första stycket som ingress och bygger
  innehållsförteckningen av sidans h2-rubriker (som prototypens sida.html).
*/
(() => {
  const root = document.querySelector("[data-page-toc]");
  if (!root) return;
  const body = root.querySelector("[data-toc-body]");
  const toc = root.querySelector("[data-toc]");
  const head = root.querySelector(".page-head");
  if (!body || !toc || !head) return;

  const first = body.firstElementChild;
  if (first && first.tagName === "P" && !first.querySelector("img") && first.textContent.trim()) {
    first.classList.add("lede");
    head.appendChild(first);
  }

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c]);
  const slug = (s) =>
    s
      .toLowerCase()
      .replace(/[åä]/g, "a")
      .replace(/ö/g, "o")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-|-$/g, "");

  const headings = [...body.querySelectorAll("h2")];
  if (!headings.length) return;

  const used = new Set();
  toc.innerHTML = headings
    .map((h) => {
      let id = h.id || slug(h.textContent) || "avsnitt";
      let n = 2;
      while (used.has(id)) id = `${id}-${n++}`;
      used.add(id);
      h.id = id;
      return `<li><a href="#${id}">${esc(h.textContent.trim())}</a></li>`;
    })
    .join("");
  toc.closest(".page-toc").hidden = false;

  if (!("IntersectionObserver" in window)) return;
  const links = [...toc.querySelectorAll("a")];
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) links.forEach((a) => a.classList.toggle("is-active", a.getAttribute("href") === `#${en.target.id}`));
      });
    },
    { rootMargin: "-20% 0px -70% 0px" }
  );
  headings.forEach((h) => io.observe(h));
})();
